/**
 * Actions
 * Set of consistently named constants that we can import and use across the
 * site, mostly for usage in partnership with the singleton event bus
 */

export const MODAL_OPEN = "MODAL_OPEN";
export const MODAL_CLOSE = "MODAL_CLOSE";
export const MODAL_UPDATE = "MODAL_UPDATE";
